import { FC, useCallback } from 'react';
import { SortOrder } from 'utils/array';
import SortableTable from 'components/UI/Table/SortableTable';
import { useNavigate } from 'react-router';
import { useAppDispatch } from 'hooks/redux';
import * as routes from 'router/Routes';
import { fetchSoftwareById } from 'store/softwareState/softwareState';
import { Subscription } from 'models/husqiotbus';

const headerCells = [
  {
    title: 'husqiotbus.service_name',
    sortable: true,
  },
];

export type TableSubscription = {
  name: string;
  link: string;
};

type SubscriptionTableProps = {
  subscriptions: Subscription[];
};

const SubscriptioTable: FC<SubscriptionTableProps> = ({
  subscriptions,
}) => {
  // State
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const table: TableSubscription[] = subscriptions.map((subscription: Subscription) => {
    const { service } = subscription;
    const sub = {
      name: service || '–',
      link: service || '–',
    };
    return sub;
  });


  // Fetch software and navigate
  const onClick = useCallback(
    (id: string) => {
      if (id) {
        dispatch(fetchSoftwareById(id));
      }
      navigate(`${routes.HUSQIOTBUS_SUBSCRIPTIONS}/${id}`);
    },
    [dispatch, navigate]
  );
  return (
    <SortableTable
      headerCells={headerCells}
      bodyRows={table}
      onClick={onClick}
      sortOrder={SortOrder.Asc}
      sortIndex={0}
    />
  );
};

export default SubscriptioTable;
